import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import http from "./services/http-common";
import socket from "./services/socket.service";

import "./filters";
import "./mixins/swal.mixin";

import SortedTablePlugin from "vue-sorted-table";
import VueClipboard from "vue-clipboard2";
import Loading from "vue-loading-overlay";
import vSelect from "vue-select";
import VueSweetalert2 from "vue-sweetalert2";
import VueMask from "v-mask";
import VueHtmlToPaper from "vue-html-to-paper";
import CKEditor from "@ckeditor/ckeditor5-vue2";

import "vue-loading-overlay/dist/vue-loading.css";
import "vue-select/dist/vue-select.css";
import "sweetalert2/dist/sweetalert2.min.css";

import "./assets/vali-admin-master/docs/css/main.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/vali-admin-master/docs/js/bootstrap.min.js";

Vue.config.productionTip = false;

/* GLOBAL PROTOTYPE */

Vue.prototype.$http = http;
Vue.prototype.$socket = socket;

Vue.prototype.$http.defaults.headers.post["Content-Type"] = "application/json";

/* PLUGINS */

Vue.use(SortedTablePlugin);
Vue.use(VueClipboard);
Vue.use(Loading);
Vue.use(VueSweetalert2);
Vue.use(VueMask);
Vue.use(CKEditor);

/* COMPONENTS */

Vue.component("loading", Loading);
Vue.component("v-select", vSelect);
Vue.component("pagination", require("laravel-vue-pagination"));

/* HTML TO PAPER */

const printOptions = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css"
  ],
  timeout: 1000,
  autoClose: true,
  windowTitle: window.document.title
};

Vue.use(VueHtmlToPaper, printOptions);

/* AUTH INIT */

async function initAuth() {

  const token = localStorage.getItem("token");

  if (token) {

    http.defaults.headers.common.Authorization = `Bearer ${token}`;

    try {
      await store.dispatch("fetchUser");
    } catch (e) {
      console.log("Session expired");
    }

  }

}

initAuth();

/* VUE INSTANCE */

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");